"use strict";

exports.__esModule = true;
exports.DeviceListContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of devices to consumers.
 * @component
 */

var DeviceListContext = exports.DeviceListContext = (0, _Utils.createEnhancedContext)({
  propName: "devices"
});